import React from 'react';
import { Grid } from '@material-ui/core';
import * as assets from '@assets';
import { CustomizedTypography } from '@components/Customized';

const EmptyScreenPresenter: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ height: '100%' }}
    >
      <img
        src={assets.EmptyNotification}
        alt=""
        width={102}
        height={102}
        style={{ marginBottom: 24 }}
      />
      <CustomizedTypography
        variant="body2"
        color="textPrimary"
        fontWeight="500"
      >
        도착한 알림이 없어요
      </CustomizedTypography>
    </Grid>
  );
};

export default EmptyScreenPresenter;
